import React, { useState, useEffect } from "react";
import Menu from "../Menu";
import { http } from "../../services/http";
import { useAlert } from "react-alert";
import { PagingState, EditingState, CustomPaging, FilteringState } from "@devexpress/dx-react-grid";
import {
  Grid,
  Table,
  TableHeaderRow,
  PagingPanel,
  TableEditRow,
  TableEditColumn,
  TableFilterRow,
  TableColumnVisibility,
  TableFixedColumns,
} from "@devexpress/dx-react-grid-material-ui";
import { QueryString, Create, Update, Remove, ExportXlsx, TIMER_FILTER, APPNAME_AUTOMACAOCARGAACD } from "../utils/react_grid_utils";
import { editColumnMessages } from "../utils/react_grid_edit_command_localization";
import Import from "../utils/import";
import authenticatedUserContext from "../security/AuthenticatedUserContext";
import Header from "../Header";
import { ProcedimentoAacdTypeProvider } from "../utils/react_grid_procedimento_aacd_column";
import { CodigoD2iAacdTypeProvider } from "../utils/react_grid_codigo_d2i_aacd_column";

const getRowId = (row) => row.id;
const api_resource = "carga-aacd/de-para-procedimentos";

const buildProcedimentoPayload = (data) => {
  const payload = {
    codigo_aacd: data?.codigo_aacd ?? "",
    procedimento_d2i: data?.procedimento_d2i ?? "",
    codigo_d2i: data?.codigo_d2i ?? "",
  };

  if (data?.id !== undefined && data?.id !== null) {
    payload.id = data.id;
  }

  return payload;
};

export default function DeParaProcedimentosAACDTable() {
  const alert = useAlert();

  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize] = useState(10);
  const [totalItens, setTotalItens] = useState(10);
  const [rows, setRows] = useState([]);
  const [tableColumnExtensions] = useState([
    { columnName: "id", width: 60 },
    { columnName: "codigo_aacd", width: 400 },
    { columnName: "procedimento_d2i", width: 400 },
    { columnName: "codigo_d2i", width: 120 },
  ]);
  const [filteringStateColumnExtensions] = useState([]);
  const [defaultHiddenColumnNames] = useState(["id"]);
  const [editingRowIds, setEditingRowIds] = useState([]);
  const [addedRows, setAddedRows] = useState([]);
  const [rowChanges, setRowChanges] = useState({});
  const [filtersApi, setFiltersApi] = useState([]);

  const [tempRelatedValues, setTempRelatedValues] = useState({});

  useEffect(() => {
    window.updateRowField = (rowId, fieldName, value) => {
      if (rowId === 0 || rowId === undefined || rowId === null) {
        setTempRelatedValues((prev) => ({
          ...prev,
          [fieldName]: value,
        }));
      } else {
        setRowChanges((prev) => {
          const currentChanges = prev[rowId] || {};
          return {
            ...prev,
            [rowId]: {
              ...currentChanges,
              [fieldName]: value,
            },
          };
        });
      }
    };

    return () => {
      delete window.updateRowField;
    };
  }, []);

  useEffect(() => {
    if (Object.keys(tempRelatedValues).length > 0) {
      if (addedRows.length > 0) {
        setAddedRows((prev) =>
          prev.map((row) => ({
            ...row,
            ...tempRelatedValues,
          }))
        );
      }

      if (Object.keys(rowChanges).length > 0) {
        setRowChanges((prev) => {
          const updated = {};
          Object.keys(prev).forEach((rowId) => {
            updated[rowId] = {
              ...prev[rowId],
              ...tempRelatedValues,
            };
          });
          return updated;
        });
      }
    }
  }, [tempRelatedValues]);

  function get(page, filters) {
    const queryString = QueryString(page, pageSize, filters);
    http.get(api_resource + queryString).then(
      (response) => {
        addRows(response?.data?.data);
        setTotalItens(response?.data?.total);
      },
      (error) => {
        console.log(error);
      }
    );
  }

  function addRows(rows) {
    setRows(rows);
  }

  useEffect(() => {
    get(0, []);
  }, []);

  const [timer, setTimer] = useState(null);

  function handleFilters(filters) {
    clearTimeout(timer);
    setFiltersApi(filters);

    setTimer(
      setTimeout(function () {
        get(pageIndex, filters);
      }, TIMER_FILTER)
    );
  }

  function handlePage(page) {
    setPageIndex(page);
    get(page, filtersApi);
  }

  const changeAddedRows = (value) => {
    const initialized = value.map((row) => {
      if (Object.keys(row).length) {
        const updatedRow = { ...row, ...tempRelatedValues };
        return updatedRow;
      }
      return {};
    });

    setAddedRows(initialized);
    if (initialized.length > 0 && Object.keys(initialized[0]).length > 0) {
      setTempRelatedValues({});
    }
  };

  const handleRowChanges = (changes) => {
    const updatedChanges = { ...changes };

    if (Object.keys(tempRelatedValues).length > 0) {
      Object.keys(updatedChanges).forEach((rowId) => {
        updatedChanges[rowId] = {
          ...updatedChanges[rowId],
          ...tempRelatedValues,
        };
      });

      setTimeout(() => setTempRelatedValues({}), 100);
    }

    setRowChanges(updatedChanges);
  };

  const commitChanges = ({ added, changed, deleted }) => {
    let changedRows;
    if (added && added.length > 0) {
      const payload = buildProcedimentoPayload(added[0]);
      Create(api_resource, payload, alert).then((response) => {
        var new_row = response.data[0];
        const startingAddedId = rows.length > 0 ? rows[rows.length - 1].id + 1 : 0;
        changedRows = [
          ...added.map((row, index) => ({
            id: startingAddedId + index,
            ...new_row,
          })),
          ...rows,
        ];
        setRows(changedRows);
      });
    }
    if (changed && Object.keys(changed).length > 0) {
      changedRows = rows.map((row) => (changed[row.id] ? { ...row, ...changed[row.id] } : row));
      var item = changedRows.find((row) => changed[row.id]);
      if (item) {
        const payload = buildProcedimentoPayload(item);
        Update(api_resource, payload, alert);
      }
      setRows(changedRows);
    }
    if (deleted && deleted.length > 0) {
      var confirmado = window.confirm("Confirma a exclusão?");
      if (confirmado === true) {
        Remove(api_resource, deleted[0], alert);
        const deletedSet = new Set(deleted);
        changedRows = rows.filter((row) => !deletedSet.has(row.id));
      } else {
        changedRows = rows;
      }
      setRows(changedRows);
    }
  };

  const columns = [
    { name: "id", title: "ID" },
    { name: "codigo_aacd", title: "Procedimento AACD" },
    { name: "procedimento_d2i", title: "Procedimento D2I" },
    { name: "codigo_d2i", title: "Código D2I" },
  ];

  const [procedimentoColumns] = useState(["procedimento_d2i"]);
  const [codigoD2iColumns] = useState(["codigo_d2i"]);

  return (
    <div id="wrapper">
      <Menu />
      <div id="page-wrapper" className="gray-bg">
        <Header />
        <div className="row wrapper border-bottom white-bg page-heading">
          <div className="col-lg-10">
            <h2>De-Para Procedimentos AACD</h2>
          </div>
          <div className="col-lg-2">
            <button className="btn btn-primary btn-sm" style={{ marginTop: "20px" }} type="button" onClick={() => ExportXlsx(api_resource, alert)}>
              Exportar
            </button>
            <Import api_resource={api_resource} alert={alert} appname={APPNAME_AUTOMACAOCARGAACD} excluir={true} onFinish={() => get(0, [])} />
          </div>
        </div>
        <div className="wrapper wrapper-content animated fadeInRight">
          <div className="row">
            <div className="col-lg-12">
              <div className="ibox ">
                <div className="ibox-content">
                  <Grid rows={rows} columns={columns} getRowId={getRowId}>
                    <PagingState currentPage={pageIndex} pageSize={pageSize} onCurrentPageChange={handlePage} />
                    <EditingState
                      editingRowIds={editingRowIds}
                      onEditingRowIdsChange={setEditingRowIds}
                      rowChanges={rowChanges}
                      onRowChangesChange={handleRowChanges}
                      addedRows={addedRows}
                      onAddedRowsChange={changeAddedRows}
                      onCommitChanges={commitChanges}
                      columnExtensions={tableColumnExtensions}
                    />
                    <FilteringState onFiltersChange={handleFilters} columnExtensions={filteringStateColumnExtensions} />
                    <ProcedimentoAacdTypeProvider for={procedimentoColumns} />
                    <CodigoD2iAacdTypeProvider for={codigoD2iColumns} />
                    <Table columnExtensions={tableColumnExtensions} />
                    <TableHeaderRow />
                    <TableColumnVisibility defaultHiddenColumnNames={defaultHiddenColumnNames} />
                    <TableEditRow />
                    {authenticatedUserContext.allow_edit(APPNAME_AUTOMACAOCARGAACD) === true ? (
                      <TableEditColumn showAddCommand={!addedRows.length} showEditCommand showDeleteCommand messages={editColumnMessages} />
                    ) : (
                      <></>
                    )}
                    <CustomPaging totalCount={totalItens} />
                    <PagingPanel />
                    <TableFilterRow />
                    <TableFixedColumns leftColumns={[TableEditColumn.COLUMN_TYPE]} />
                  </Grid>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
